import { FormattedMessage } from "react-intl";
import { DateRangeType } from "../../lib/graphql";
import { useDateRangeTypeOptions } from "../../lib/hooks/basic/basic";
import {
  isRangeType,
  RangePicker,
  RangePickerProps,
  RangePickerValue,
} from "../form/DatePicker";
import { SelectField } from "../form/SelectField";
import { Space } from "../shared/Space";
import { useMediaXs } from "../../lib/hooks/basic/media";

export function DateRangeInput({
  rangeType,
  setRangeType,
  documentDate,
  setDocumentDate,
  rangePickerProps,
  style,
}: {
  rangeType: DateRangeType | null;
  setRangeType: (rangeType: DateRangeType | null) => void;
  documentDate: RangePickerValue;
  setDocumentDate: (date: RangePickerValue) => void;
  rangePickerProps?: RangePickerProps;
  style?: React.CSSProperties;
}) {
  const isXs = useMediaXs();

  return (
    <Space vertical={isXs} style={isXs ? { width: "100%" } : undefined}>
      <SelectField
        optionsHook={useDateRangeTypeOptions}
        showSearch={false}
        onChange={(value) => setRangeType(value)}
        placeholder={
          <FormattedMessage
            id="dashboard.filterByDate"
            defaultMessage="Filter by date"
          />
        }
        style={style}
        className="rounded"
      />

      {isRangeType(rangeType) && (
        <RangePicker
          value={documentDate}
          onChange={setDocumentDate}
          picker={rangeType === DateRangeType.MonthRange ? "month" : "date"}
          className="rounded"
          {...rangePickerProps}
        />
      )}
    </Space>
  );
}
